
import axios from 'axios';

import { AddParcelToBagStatus, BagDto, GroupedBagCodesResponse, ManifestBagType, ParcelItemsDto, WeightType } from '../model/manualSorting.tsx';
import { sort_center_api } from '@shared/api/index.tsx';
import { ManualWeight } from '@shared/types/parcel';
import { makeQueryString } from '@shared/utils/pagging.ts';
import { Filter } from '@uni-space/uni-components';
import { PageList } from '@shared/types/filter.ts';
import { FetchCtx } from '@shared/types/api';
import { WeightUnit } from '@shared/types/weight.ts';
import { printPdfRouted } from '@shared/utils/printRouter';

export async function getAllBags(
  page: number | undefined,
  pageSize: number | undefined,
  filters: Filter[] | undefined,
  showAll: boolean,
  ctx?: FetchCtx,
): Promise<PageList<BagDto>> {
  const baseFilters: Filter[] = [{ name: 'showAll', value: String(showAll) }];
  const nextFilters = filters ? [...filters, ...baseFilters] : baseFilters;
  const url: string = `v1/bags?` + makeQueryString(page, pageSize, nextFilters);
  const result = await sort_center_api<PageList<BagDto>>(url, { signal: ctx?.signal });
  return result.data;
}

export async function getSortAllBags(
  page: number | undefined,
  pageSize: number | undefined,
  filters: Filter[] | undefined,
): Promise<PageList<BagDto>> {
  const url: string = `/v1/hardware-bags?` + makeQueryString(page, pageSize, filters);
  const result = await sort_center_api<PageList<BagDto>>(url);
  return result.data;
}



export async function getSortedBags(): Promise<GroupedBagCodesResponse> {
  const url: string = `v1/sorting-directory/grouped-bag-codes`;
  const result = await sort_center_api<GroupedBagCodesResponse>(url);
  return result.data;
}

export async function createBags(bagCode: string, regionZone: string, type: ManifestBagType, isReturn: boolean) {
  const url: string = `/v1/bags/`;
  // Для возвратного мешка bagCode не указывается — бэкенд его игнорирует
  const body = isReturn ? { type, isReturn } : { bagCode, regionZone, type, isReturn };
  return sort_center_api.post(url, body);
}

export async function getParcelByBagId(bagId: number) {
  const url: string = `/v1/parcels/${bagId}/bag`;
  return await sort_center_api<ParcelItemsDto>(url);
}

export async function addParcelToBag(trackNumber: string, bagId: number): Promise<{ status: AddParcelToBagStatus }> {
  const url: string = `/v1/bags/parcel`;
  const res = await sort_center_api.post(url, { trackNumber, bagId });
  return res.data;
}

export async function closeBag(bagId: number, closedNumber: string, grossWeight?: number) {
  const url: string = `/v1/bags/close`;
  const hasGrossWeight = grossWeight !== undefined && grossWeight !== null && !Number.isNaN(grossWeight);
  await sort_center_api.post(url, {
    bagId,
    closedNumber,
    ...(hasGrossWeight ? { grossWeight: { value: grossWeight, unit: WeightUnit.kg } } : {}),
  });
}

export async function printLabel(bagId: number) {
  const url: string = `/v1/bags/${bagId}/label`;
  const response = await sort_center_api.get(url, {
    responseType: 'blob',
  });

  // Куда печатать, решает маршрутизатор: выбран принтер — облачная печать, иначе (и на
  // любой ошибке отправки) прежний диалог print-js с модалкой загрузки.
  const blob = new Blob([response.data], {
    type: 'application/pdf',
  });
  await printPdfRouted(blob, { showModal: true });
}
// Локальный сервис весов на рабочем месте оператора; вес приходит в граммах.
// Запрос идёт «голым» axios: интерцепторы sort_center_api добавляют Authorization,
// который не покрывается Access-Control-Allow-Headers: * и валит CORS preflight.
export async function getScalesWeight(signal?: AbortSignal): Promise<ManualWeight | null> {
  const url = 'http://localhost:7887/';
  try {
    const res = await axios.get<ManualWeight>(url, { signal });
    return res.data ?? null;
  } catch {
    return null;
  }
}

export async function getActualWeightBag(bagId: number) {
  const url: string = `/v1/bags/${bagId}/weight`;
  const response = await sort_center_api<WeightType>(url);
  return response.data;
}
